import { HomeComponent } from './home/home.component';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChapterComponent } from './gallery/chapter/chapter.component';
import { canDeactivateLeitorGuard } from './guards/can-deactivate-leitor.guard';
import { canActivateBook2Guard } from './guards/can-activate-book2.guard';


const routes: Routes = [
    { path: '', component: HomeComponent },

    {
        path: 'preview',
        loadComponent: () => import('./leitor-page/leitor-page.component').then(m => m.LeitorPageComponent),
        canDeactivate: [canDeactivateLeitorGuard]
    },

    {
      path: 'bienal/reinado-de-vidro',
      loadComponent: () => import('./leitor-book2/leitor-book2.component').then(m => m.LeitorBook2Component),
      canActivate: [canActivateBook2Guard]
    },

    {
        path: "colecao/capitulo/:chapter",
        loadComponent: () => import('./gallery/chapter/chapter.component').then(mod =>
          mod.ChapterComponent)
    },
    {
        path: "fanarts",
        loadComponent: () => import('./fanartes/fanartes.component').then(mod =>
          mod.FanartesComponent)
    },
    {
        path: "bienal",
        loadComponent: () => import('./bienal/bienal.component').then(mod =>
          mod.BienalComponent)
    }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
